import s from './TextArea.module.scss';
import {TTextAreaProps} from "@/app/[locale]/common/components/TextArea/types";

export const TextArea = (
    {
        value,
        size = 'medium',
        textSize = 'medium',
        placeholder,
        register,
        required,
        minLengthSchema,
        validationPattern,
        label,
        children,
        onChange
    }: TTextAreaProps) => {

    const validationRules = {
        required,
        minLength: minLengthSchema,
        pattern: validationPattern,
    };

    return (
        <textarea
            value={value}
            placeholder={placeholder}
            className={`${s.textarea} ${s[size]} ${s[`textareaTextSize_${textSize}`]}`}
            {...register && register(label as string, validationRules)}
            onChange={onChange}
        >{ children }</textarea>
    );
};